import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ProMenu } from '@fle-ui/pro-layout';
import commonStore from '../../stores/common';
import Cookies from 'js-cookie';
import ConsoleHeader from '@fle-ui/pro-console-header';
import { Modal } from '@fle-ui/next';
import BasicRouter from './router';

import { YUN_YING_MAIN_HOST as ORIGIN, BASE_ROUTER } from '../../config';

import baseRouterConfig from '../../config/router/base';

import { AppRoute, AppRouter } from '@ice/stark';
import Sandbox from '@ice/sandbox';
import Loading from '../../components/Loading';
import ProResult from '@fle-ui/pro-result';

import _ from 'lodash';

const CommonRouteConfig = {
	sandbox: true,
	umd: true,
	// FIXME: cached
	cached: false
};
const socialCardEntry =
	process.env.NODE_ENV === 'development' ? '/socialCard/' : `${ORIGIN}socialCard/`;
const socialCardEntryScript = /\/socialCard\/js\/index\.[^/]+\.js(?:\?|$)/;

const fetchMicroAppAsset = async (input, init) => {
	const response = await window.fetch(input, init);
	const url = typeof input === 'string' ? input : input.url;
	if (!response.ok || !socialCardEntryScript.test(url)) return response;

	// The legacy bundle assumes that the host application is deployed at root.
	const source = await response.text();
	const patchedSource = source.replace(
		/(["'])\/home\/application\/socialCard\1/g,
		`$1${BASE_ROUTER}/home/application/socialCard$1`
	);
	const headers = new Headers(response.headers);
	headers.delete('content-length');

	return new Response(patchedSource, {
		status: response.status,
		statusText: response.statusText,
		headers
	});
};

const prepareSocialCardChunk = (chunk) => {
	const modules = chunk && chunk[1];
	if (!modules) return chunk;

	Object.keys(modules).forEach((moduleId) => {
		const factory = modules[moduleId];
		if (
			typeof factory !== 'function' ||
			!Function.prototype.toString.call(factory).includes('__mobxGlobals')
		) {
			return;
		}

		// MobX 6 is delivered in a native webpack chunk, outside the proxy sandbox.
		modules[moduleId] = function isolatedMobxFactory(...args) {
			const result = factory.apply(this, args);
			const moduleExports = args[1] || {};
			const configure = Object.keys(moduleExports)
				.map((key) => moduleExports[key])
				.find(
					(exported) =>
						typeof exported === 'function' &&
						Function.prototype.toString.call(exported).includes('isolateGlobalState')
				);

			if (configure) configure({ isolateGlobalState: true });
			return result;
		};
	});

	return chunk;
};

const createSocialCardChunkQueue = () => {
	const chunkQueue = [];
	let push = Array.prototype.push.bind(chunkQueue);

	Object.defineProperty(chunkQueue, 'push', {
		configurable: true,
		get: () => push,
		set: (nextPush) => {
			push = (chunk) => nextPush(prepareSocialCardChunk(chunk));
		}
	});

	return chunkQueue;
};

class SocialCardSandbox extends Sandbox {
	createProxySandbox(injection) {
		super.createProxySandbox(injection);
		this.getSandbox().webpackChunksocialCard = createSocialCardChunkQueue();
	}
}
// url 正则
const Basic = () => {
	const history = useHistory();
	const [userInfo, setUserInfo] = React.useState({});
	const [selectKey, setSelectKey] = useState([-1]);

	const getmemberInfo = useCallback(async () => {
		let userInfo = {};
		try {
			userInfo = JSON.parse(window.localStorage.getItem('userInfo')) || {};
			setUserInfo({
				id: userInfo.outUserId,
				name: userInfo.userName
			});
		} catch (ex) {
			console.warn(ex);
		}
	}, [history]);

	useEffect(() => {
		getmemberInfo().finally();
	}, [getmemberInfo]);

	useEffect(() => {
		getRouterConfig();
	}, []);

	const getRouterConfig = () => {
		let thisIndex = [-1];

		baseRouterConfig.forEach((item, index) => {
			if (window.location.pathname.startsWith(`${BASE_ROUTER}${item.path}`)) {
				thisIndex = [index];
			}
		});

		setSelectKey(thisIndex);
	};

	const handleLoginOut = async () => {
		Cookies.remove('supplier_token');
		Modal.confirm({
			title: '是否确认登出？',
			onOk() {
				commonStore.logout().then(() => {
					history.push('/login');
				});
			}
		});
	};
	const handleTopMenu = (info) => {
		history.push(info.key);
	};
	const onAppLeave = () => {
		window.webpackJsonp = [];
	};

	const handleLeftMenuApply = (info) => {
		if (info.type === 'link') {
			// window.open(info.path)
			location.href = info.path;
		} else {
			history.push(info.path);
			setSelectKey([info.index]);
		}
	};

	const commonProps = { id: 'fx-operate-admin' };

	return (
		<>
			{!window.__POWERED_BY_WUJIE__ && (
				<>
					<ProMenu
						styleType="left"
						onLeftMenuApply={handleLeftMenuApply}
						defaultSelectedKey={selectKey}
						appProps={{
							icon: 'https://qa-yunying.fxqifu.com/panguOperate/favicon.ico'
						}}
						leftMenuItems={baseRouterConfig}
					/>

					<ConsoleHeader
						userApplyName="盘古中台"
						isLoading={false}
						userInfo={userInfo}
						sliderInfo={null}
						onExit={handleLoginOut}
						fastApply={[]}
						theme="light"
						isFixed
						style={{ left: 64, transition: '0.2s all', width: 'auto', height: 60 }}
					/>
				</>
			)}

			<AppRouter
				LoadingComponent={Loading}
				onAppLeave={onAppLeave}
				ErrorComponent={<ProResult type="loadingFail" />}
				NotFoundComponent={<ProResult type="404" />}
				shouldAssetsRemove={() => false}
				fetch={fetchMicroAppAsset}
			>
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/order" entry={`${ORIGIN}order`} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/trading" entry={`${ORIGIN}trading`} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/role" entry={`${ORIGIN}role`} />

				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/cms/" entry={`${ORIGIN}cms`} props={commonProps} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/intelligent/" entry={`${ORIGIN}intelligent`} props={commonProps} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/operateSupplier/" entry={`${ORIGIN}operateSupplier`} props={commonProps} />
				<AppRoute
					{...CommonRouteConfig}
					sandbox={SocialCardSandbox}
					path="/panguOperate/home/application/socialCard/"
					entry={socialCardEntry}
					props={commonProps}
				/>

				<AppRoute
					path="*"
					umd={false}
					render={() => {
						return (
							<section className="main-route-wrap">
								<BasicRouter />
							</section>
						);
					}}
				/>
			</AppRouter>
		</>
	);
};

export default observer(Basic);
